import { Log, UserManager } from 'oidc-client-ts'
import { Environment } from '../environment'

export const USER_MANAGER = new UserManager({
  authority: Environment.IdentityUrl,
  client_id: Environment.IndentityClientId,
  redirect_uri: `${location.origin}/signin-callback.html`,
  silent_redirect_uri: `${location.origin}/silent-renew.html`,
  post_logout_redirect_uri: `${location.origin}/index.html`,
  response_type: 'code',
  scope:
    'openid profile contracts customers reports roles documents workflows offline_access phone email orders locations notifications tags',
  loadUserInfo: true,
})

Log.setLogger(console)
Log.setLevel(Log.NONE)
